import React from "react";
import {Box, Switch} from "@mui/material";

export default function AutomationStatusSwitch({row, handleStatusUpdate}) {

    const handleOnChange = (checked) => {
        handleStatusUpdate({status: checked, ruleId: row?.id, trafficSourceId: row?.trafficSourceId, workspaceId: row?.workspaceId});
    };

    if (!row.hasOwnProperty("status")) {
        return "";
    }

    return (
        <Box sx={{textAlign: "center", position: "relative", top: "-1px"}} key={row?.id}>
            <Switch
                checked={row?.status === "active"}
                onChange={(e) => handleOnChange(e?.target?.checked)}
                name="statusSwitch"
                color="primary"
                size="small"
            />
        </Box>
    );
}